const size = {
    sm: '576px',
    md: '1200px',
}
const device = {
    sm: `(min-width: ${size.sm})`,
    md: `(max-width: ${size.md})`,
    lg: `(min-width: ${size.md})`
}
export default { size, device }